import script from "./SellerSettlement.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerSettlement.vue?vue&type=script&setup=true&lang=js"

import "./SellerSettlement.vue?vue&type=style&index=0&id=76e032d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e032d9"]])

export default __exports__